import styled from 'styled-components';

const ScrollableOverlayBody = styled.div`
  flex: auto;
  overflow-y: auto;
`;

export default ScrollableOverlayBody;
